import {z as zod} from "zod";

export type TuffexProductCollectionWorkspaceCapabilityConfiguration = Record<string, never>;

export const tuffexProductCollectionWorkspaceCapabilityConfigurationValidator: zod.ZodType<TuffexProductCollectionWorkspaceCapabilityConfiguration> = zod.strictObject({});
